var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3914",
    "data-name": "Rectangle 3914",
    width: 24,
    height: 24,
    transform: "translate(1549 -167)",
    fill: "#fb8f01",
    stroke: "#fc8f01",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0628\\u0631\\u062A\\u0631\\u06CC\\u0646_\\u0647\\u0627",
    "data-name": "\\u0628\\u0631\\u062A\\u0631\\u06CC\\u0646  \\u0647\\u0627",
    transform: "translate(-1549 167)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10182",
    "data-name": "Group 10182",
    transform: "translate(1552 -163.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M4.157,16.371a.694.694,0,0,1-.386-.115.557.557,0,0,1-.232-.664l2.045-5.472L.284,6.839A.558.558,0,0,1,.029,6.18a.645.645,0,0,1,.622-.416H7.189L9.162.279A.593.593,0,0,1,9.376,0V13.092L4.54,16.259A.7.7,0,0,1,4.157,16.371Z",
    transform: "translate(0 0.129)",
    fill: "#fb8f01",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M15.3,18.748a.608.608,0,0,1-.352-.111L10.127,15.2,5.3,18.637a.609.609,0,0,1-.708,0,.583.583,0,0,1-.213-.663L6.264,12.5,1.389,9.217a.584.584,0,0,1-.234-.66.6.6,0,0,1,.572-.416H7.741L9.556,2.657a.6.6,0,0,1,1.141,0l1.815,5.487h6.015a.6.6,0,0,1,.573.415.584.584,0,0,1-.234.66L13.99,12.5l1.88,5.47a.58.58,0,0,1-.081.532A.6.6,0,0,1,15.3,18.748Z",
    transform: "translate(-1.128 -2.249)",
    fill: "none",
    stroke: "#fc8f01",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarM);
export default __webpack_public_path__ + "static/media/star_m.ea1bf34ab6a3da622c0ba6528feadd4c.svg";
export { ForwardRef as ReactComponent };